export const getLoginDestination = (account = {}) => {
  if (account.is_admin) {
    return "/admin/dashboard";
  }

  if (account.type_id == null || account.type_name == null) {
    return "/general/complete";
  }

  return "/user/profile";
};
